import { Directive, OnInit, inject } from '@angular/core';
import { Tooltip } from 'primeng/tooltip';
import { GlobalConstants } from 'src/app/base/global.constants';

@Directive({
  selector: '[pTooltip]',
  standalone: false //NOSONAR
})
export class FastTooltipDirective implements OnInit {
  private readonly tooltip = inject(Tooltip, { self: true, optional: true });

  ngOnInit(): void {
    if (this.tooltip && !this.tooltip.showDelay) {
      this.tooltip.showDelay = GlobalConstants.tooltipShowDelay!;

      // Update the internal options state PrimeNG specifically relies on
      if (typeof this.tooltip.setOption === 'function') {
        this.tooltip.setOption({ showDelay: GlobalConstants.tooltipShowDelay });
      }
    }
  }
}
